import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "./../../environments/environment";

const url = environment.url;

// const url = "http://localhost:5000/";
// const url = "http://18.142.179.7:5000/";

@Injectable()
export class CompanyService {
  constructor(private http: HttpClient) {}

  getCompany(id) {
    return this.http.get(url + "company/" + id);
  }

  getCompanyItems(id) {
    return this.http.get(url + "company/items/" + id);
  }

  storeCompanyDetails(data) {
    return this.http.post(url + "save/company", data);
  }

  storeItemDetails(data) {
    return this.http.post(url + "save/company/items", data);
  }

  removeCompany(id) {
    return this.http.delete(url + "company/" + id);
  }

  removeCompanyItem(id) {
    return this.http.delete(url + "company/item/" + id);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/company.service.ts